import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Favorite = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fill={color}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.10326 2.02054C7.47007 1.2773 8.52991 1.2773 8.89673 2.02054L10.2913 4.84627L13.4097 5.2994C14.2299 5.41858 14.5574 6.42656 13.9639 7.00509L11.7074 9.20462L12.2401 12.3104C12.3802 13.1273 11.5228 13.7503 10.7892 13.3646L7.99999 11.8982L5.21083 13.3646C4.4772 13.7503 3.61977 13.1273 3.75988 12.3104L4.29256 9.20462L2.03608 7.00509C1.44257 6.42656 1.77008 5.41858 2.5903 5.2994L5.70867 4.84627L7.10326 2.02054ZM7.99999 2.46311L6.60541 5.28884C6.45975 5.58398 6.17818 5.78855 5.85247 5.83588L2.73409 6.28901L4.99057 8.48853C5.22626 8.71827 5.33381 9.04927 5.27817 9.37366L4.74549 12.4794L7.53465 11.0131C7.82597 10.8599 8.17401 10.8599 8.46533 11.0131L11.2545 12.4794L10.7218 9.37366C10.6662 9.04927 10.7737 8.71827 11.0094 8.48853L13.2659 6.28901L10.1475 5.83588C9.8218 5.78855 9.54024 5.58398 9.39457 5.28884L7.99999 2.46311Z"
      />
    </svg>
  )
})

export default Favorite
